module.exports = __webpack_public_path__ + "static/media/battery.eccb1928.svg";